/**
 * Unicode character constants
 */
export const UNICODE = {
  NON_BREAKING_SPACE: '\u00A0',
  NON_BREAKING_HYPHEN: '\u2011',
  NEWLINE: '\n'
} as const
